import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { initiateFirebaseLoginWithToken } from '../store/slices/auth';
import { useAppDispatch } from '../store/store';
import { setSearchValue } from '../utils/http';
import Loading from './Loading';

const FirebaseTokenLogin = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  // Initiate login on mount
  useEffect(() => {
    const token = searchParams.get('token');
    const redirect = searchParams.get('redirect');

    if (!token) {
      // No token provided, redirect to login page
      navigate('/web/login');
      return;
    }

    // Store redirect in URL query params so LoginListener can pick it up
    if (redirect) {
      setSearchValue(window, 'redirect', redirect);
    }

    // Initiate Firebase login with the provided token
    initiateFirebaseLoginWithToken(dispatch, token);
  }, [searchParams, navigate, dispatch]);

  // LoginListener will handle the redirect after auth completes
  return <Loading />;
};

export default FirebaseTokenLogin;
